module.exports = __webpack_public_path__ + "static/media/Aloha-Mundo.7960dfc6.mp4";